module.exports = __webpack_public_path__ + "img/sq4d_03.2a536324.jpg";